import {
  workforceConfigurationDialog,
  workforceOperationalLayout,
  workforceOperationalTypography,
} from "../workforce-design-system.js";

export const adminOperationalLayout = {
  ...workforceOperationalLayout,
  detailDrawerWidth: 1120,
  mobileCardRadius: workforceOperationalLayout.panelRadius,
  sidebarWidth: 224,
} as const;

export const adminOperationalTypography = workforceOperationalTypography;

export const adminConfigurationDialog = workforceConfigurationDialog;
